import { AxiosResponse } from 'axios';

import { axiosIntance } from '../../../config/ApiConfig';
import {
  CashRegister,
  ResponseCashRegister,
} from '../../../types/cashRegister/CashRegister';

export const CashRegisterDao = {
  list: (
    accountId: string,
    page: number | string | null,
    limit: number | string | null,
    search: string | null,
    filter: string | null
  ): Promise<AxiosResponse<ResponseCashRegister>> => {
    let query = '';
    if (search) {
      query = `&filter=${search}`;
    }
    if (filter) {
      filter = `&${filter}`;
    } else {
      filter = '';
    }

    if (!page) {
      page = 1;
    }
    if (!limit) {
      limit = 20;
    }
    return axiosIntance.get(
      `/cashRegister/list?page=${page}&limit=${limit}&accountId=${accountId}${query}${filter}`
    );
  },
  show: (
    id: string,
    accountId: string
  ): Promise<AxiosResponse<CashRegister>> => {
    return axiosIntance.get(`/cashRegister/${accountId}/${id}`);
  },
};
